"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var TreeSelectorItem_1 = __importDefault(require("./TreeSelectorItem"));
var styles_1 = require("./styles");
var TreeSelector = /** @class */ (function (_super) {
    __extends(TreeSelector, _super);
    function TreeSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            focusedItems: [],
            selectedItems: [],
        };
        _this.componentDidUpdate = function (_a) {
            var oldValue = _a.value;
            var value = _this.props.value;
            if (value && value.toString() !== oldValue.toString()) {
                _this.setSelectedItemFromStore(value);
            }
        };
        _this.componentDidMount = function () {
            var value = _this.props.value;
            if (value) {
                _this.setSelectedItemFromStore(value);
            }
        };
        _this.findItemInTreeById = function (id, treeItems) {
            if (treeItems[id]) {
                return treeItems[id];
            }
            return Object.values(treeItems).reduce(function (acc, treeItem) {
                if (acc) {
                    return acc;
                }
                if (treeItem.children && Object.keys(treeItem.children).length > 0) {
                    return _this.findItemInTreeById(id, treeItem.children);
                }
                return null;
            }, null);
        };
        _this.handleOnFocus = function (item, focused) {
            var focusedItems = _this.state.focusedItems;
            if (focused) {
                var newFocusedItems = focusedItems.slice(0, item.level - 1);
                newFocusedItems[item.level - 1] = item;
                _this.setState({ focusedItems: newFocusedItems });
            }
            else {
                _this.setState({ focusedItems: focusedItems.slice(0, item.level - 1) });
            }
        };
        _this.handleOnSelectAll = function (item, selected) {
            var focusedItems = _this.state.focusedItems;
            _this.handleOnSelect(focusedItems[item.level - 1], selected);
        };
        _this.handleOnSelectAllFirstLevel = function (_0, selected) {
            var data = _this.props.data;
            _this.updateSelectedItems(selected ? Object.values(data) : []);
        };
        _this.handleOnSelect = function (item, selected) {
            var selectedItems = _this.getSelectedItems();
            if (selected) {
                var newSelectedItems = [item].concat(selectedItems);
                // unselect all children - handle case when item is partially selected
                newSelectedItems = _this.unselectAllChildren(item, newSelectedItems);
                // loop to select parent insead of all its children
                var loopItem = item;
                var _loop_1 = function () {
                    var groupItemsMap = loopItem.syblings;
                    var groupItems = Object.values(groupItemsMap);
                    var isWholeGroupSelected = _this.isWholeGroupSelected(groupItems, newSelectedItems);
                    // if after selecting this element whole group (all its sybling items) is selected
                    if (isWholeGroupSelected && loopItem.level > 1) {
                        // unselect the whole group
                        newSelectedItems = newSelectedItems.filter(function (fItem) { return !groupItemsMap[fItem.id]; });
                        // and select the parent
                        loopItem = loopItem.parent;
                        newSelectedItems = [loopItem].concat(newSelectedItems);
                    }
                    else {
                        loopItem = null;
                    }
                };
                do {
                    _loop_1();
                } while (loopItem);
                _this.updateSelectedItems(newSelectedItems);
                // if parent is selected - and current item is not really selected
            }
            else if (_this.checkIfParentIsInList(item, selectedItems)) {
                // loop to add syblings if the all option was selected
                var loopItem_1 = item;
                var newSelectedItems = selectedItems.slice();
                var filteringCb = function (fItem) {
                    return fItem !== loopItem_1.parent && fItem !== loopItem_1;
                };
                do {
                    // add all items from the parent to selected list
                    newSelectedItems = Object.values(loopItem_1.syblings).concat(newSelectedItems).filter(filteringCb);
                    // repeat for parent
                    loopItem_1 = loopItem_1.parent;
                } while (_this.checkIfParentIsInList(loopItem_1, newSelectedItems));
                // remove current and its parent from selected items
                _this.updateSelectedItems(newSelectedItems);
            }
            else {
                var newSelectedItems = selectedItems.slice().filter(function (selectedItem) { return selectedItem !== item; });
                _this.updateSelectedItems(newSelectedItems);
            }
        };
        return _this;
    }
    TreeSelector.prototype.getSelectedItems = function () {
        var selectedItems = this.state.selectedItems;
        return selectedItems;
    };
    TreeSelector.prototype.getLevelsList = function () {
        var data = this.props.data;
        var focusedItems = this.state.focusedItems;
        var levels = [
            Object.values(data)
        ].concat(focusedItems.map(function (item) { return Object.values(item.children); }));
        return levels;
    };
    TreeSelector.prototype.setSelectedItemFromStore = function (storeValue) {
        var _this = this;
        var data = this.props.data;
        var selectedItems = storeValue.map(function (id) {
            return _this.findItemInTreeById(id, data);
        });
        this.setState({ selectedItems: selectedItems });
    };
    TreeSelector.prototype.checkIfParentIsInList = function (item, list) {
        var parent = item.parent;
        return ((parent && !list.includes(item) && list.includes(parent)) ||
            (parent && this.checkIfParentIsInList(parent, list)));
    };
    TreeSelector.prototype.checkIfTreeContainsItem = function (tree, item) {
        var _this = this;
        if (tree[item.id]) {
            return true;
        }
        return !!Object.values(tree).find(function (treeItem) {
            return treeItem.children &&
                _this.checkIfTreeContainsItem(treeItem.children, item);
        });
    };
    TreeSelector.prototype.unselectAllChildren = function (tree, list) {
        var _this = this;
        return list.filter(function (item) { return !_this.checkIfTreeContainsItem(tree.children, item); });
    };
    TreeSelector.prototype.updateSelectedItems = function (selectedItems) {
        var _a = this.props, name = _a.name, onChange = _a.onChange;
        this.setState({ selectedItems: selectedItems });
        // allow selection to be visible before sending update to redux
        setTimeout(function () {
            return onChange({
                target: {
                    name: name,
                    value: selectedItems.map(function (item) { return item.id.toString(); }),
                },
            });
        }, 0);
    };
    // item is partially selected when one of its children is selected
    TreeSelector.prototype.isPartiallySelected = function (item) {
        // if it is in selected list - not partially selected
        if (this.isSelected(item)) {
            return false;
        }
        var selectedItems = this.getSelectedItems().filter(function (x) { return x; });
        // if any of the selected items have this element as parent
        // - this element has to be partially selected
        var res = selectedItems.reduce(function (acc, selectedItem) {
            // found earlier - skip further checks
            if (acc) {
                return true;
            }
            // check for parent matching
            // eslint-disable-next-line prefer-destructuring
            var parent = selectedItem.parent;
            while (parent && parent !== item) {
                // eslint-disable-next-line prefer-destructuring
                parent = parent.parent;
            }
            // if any of the parent matched, it will be truthy, otherwise null
            return !!parent;
        }, false);
        return res;
    };
    TreeSelector.prototype.isSelected = function (item) {
        var selectedItems = this.getSelectedItems();
        var node = item;
        while (node && !selectedItems.includes(node)) {
            node = node.parent;
        }
        return !!node;
    };
    TreeSelector.prototype.isSelectedAllFirstLevel = function () {
        var selectedItems = this.getSelectedItems();
        var data = this.props.data;
        return (Object.values(data).length === selectedItems.length &&
            selectedItems.reduce(function (acc, item) { return acc && !!data[item.id]; }, true));
    };
    TreeSelector.prototype.isWholeGroupSelected = function (groupItems, selectedItems) {
        return groupItems.reduce(function (acc, groupItem) { return acc && selectedItems.includes(groupItem); }, true);
    };
    TreeSelector.prototype.render = function () {
        var _this = this;
        var _a = this.props, levelNames = _a.levelNames, height = _a.height;
        var focusedItems = this.state.focusedItems;
        var levels = this.getLevelsList();
        return (react_1.default.createElement(styles_1.Wrapper, null, levels.map(function (items, idx) {
            return items.length ? (
            /* eslint-disable react/no-array-index-key */
            react_1.default.createElement(styles_1.Level, { key: idx },
                react_1.default.createElement(styles_1.LevelTitle, null, levelNames[idx] || "Level " + (idx + 1)),
                react_1.default.createElement(styles_1.AllCheckbox, { label: "all", item: { level: idx }, selected: idx === 0
                        ? _this.isSelectedAllFirstLevel()
                        : _this.isSelected(focusedItems[idx - 1]), onSelect: idx === 0
                        ? _this.handleOnSelectAllFirstLevel
                        : _this.handleOnSelectAll }),
                react_1.default.createElement(styles_1.TreeSelectorList, { style: { height: height } }, items.map(function (item) { return (react_1.default.createElement(TreeSelectorItem_1.default, { key: item.id, label: item.name, item: item, focused: focusedItems[idx] === item, onFocus: _this.handleOnFocus, selected: _this.isSelected(item), partiallySelected: _this.isPartiallySelected(item), onSelect: _this.handleOnSelect })); })))) : null;
        })));
    };
    TreeSelector.propTypes = {
        data: prop_types_1.default.object.isRequired,
        name: prop_types_1.default.string.isRequired,
        value: prop_types_1.default.arrayOf(prop_types_1.default.string),
        onChange: prop_types_1.default.func,
        levelNames: prop_types_1.default.arrayOf(prop_types_1.default.string),
        height: prop_types_1.default.number,
    };
    TreeSelector.defaultProps = {
        onChange: function () { },
        value: null,
        levelNames: [],
        height: null,
    };
    return TreeSelector;
}(react_1.Component));
exports.default = TreeSelector;
//# sourceMappingURL=TreeSelector.js.map